module.exports = __webpack_public_path__ + "static/media/1.27d50338.png";